import { useNotificationsContext } from '../../context/NotificationsContext';

export const useNotifications = () => useNotificationsContext();
